import React, { useEffect, useState } from "react";
import {
  FaWhatsapp,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";
import Skeleton from "../ui/Skeleton";
import axiosInstance from "../axios";
import "../styles/footer.css";

const FooterSkeleton = () => {
  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div>
          <Skeleton className="footer-skeleton-title" />
          <Skeleton className="footer-skeleton-line" />
          <Skeleton className="footer-skeleton-line short" />
        </div>

        <div>
          <Skeleton className="footer-skeleton-title" />
          <Skeleton className="footer-skeleton-line" />
          <Skeleton className="footer-skeleton-line" />
        </div>

        <div>
          <Skeleton className="footer-skeleton-title" />
          <Skeleton className="footer-skeleton-line" />
          <Skeleton className="footer-skeleton-line short" />
        </div>
      </div>
    </footer>
  );
};

const Footer = () => {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchCompany = async () => {
      try {
        const res = await axiosInstance.get("/company");
        if (isMounted) {
          setCompany(res.data?.data?.[0] || null);
        }
      } catch (err) {
        console.error(err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchCompany();

    return () => {
      isMounted = false;
    };
  }, []);

  const wa = company?.whatsApp_number
    ? String(company.whatsApp_number).replace(/\D/g, "")
    : "";

  if (loading) return <FooterSkeleton />;

  return (
    <footer className="footer">
      <div className="container footer-grid">
        {/* BRAND */}
        <div className="footer-col">
          <h3 className="footer-title">Urbania</h3>
          <p className="footer-text">
            Platform properti modern untuk jual, beli, dan sewa properti dengan
            pengalaman terbaik.
          </p>
        </div>

        {/* SPACE */}
        <div className="footer-col">

        </div>

        {/* CONTACT */}
        <div className="footer-col">
          <h4 className="footer-title">Kontak</h4>

          <div className="footer-contact">
            <FaMapMarkerAlt />
            <span>{company?.address || "-"}</span>
          </div>

          <div className="footer-contact">
            <FaEnvelope />
            <span>{company?.email || "-"}</span>
          </div>

          <div className="footer-contact">
            <FaPhoneAlt />
            <span>{company?.phone_number || "-"}</span>
          </div>

          {wa && (
            <a
              href={`https://wa.me/${wa}`}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-wa-btn"
            >
              <FaWhatsapp />
              <span>Chat WhatsApp</span>
            </a>
          )}
        </div>
      </div>

      {/* COPYRIGHT */}
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Urbania. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
